import Button from "@ancon/wildcat-ui/web/orderweb/Button";
import "@ancon/wildcat-ui/web/orderweb/Button/Button.css";
import "@ancon/wildcat-ui/web/orderweb/Spinner/Spinner.css";

export default Button;
